export default "__VITE_ASSET__ip_baqM$__"